import React from 'react';
import * as Routes from 'modules/routes';
import I18n from 'modules/i18n';
import { ReferenceMaterialAssignment } from '@/types/api/LessonOverview';
import { svgAsImgSrc } from '@/components/common/Utils';
import { libraryIconFor } from './icons/libraryIcons';
import Card, { CardBody } from './Card';

type ReferenceMaterialCardProps = {
  assignments: ReferenceMaterialAssignment[],
  programId: number | string,
  type: string,
};

const ReferenceMaterialCard = ({ assignments, programId, type }: ReferenceMaterialCardProps) => {
  if (assignments == null || assignments.length === 0) return null;

  // A material whose library tag was removed has no library to name; don't take the lesson overview
  // down with it.
  const libraryLabel = assignments[0].libraryLabel || I18n.t('library');
  const { libraryTag } = assignments[0];
  const { Icon, className } = libraryIconFor(libraryTag);

  return (
    <Card
      key={`${type}-card`}
      paddedLabel
      bannerBorderColor="blue"
      labelText={libraryLabel}
      type={type}
    >
      <CardBody
        ariaLabel={libraryLabel}
        iconClassNames={className || 'tw-w-[60px]'}
        iconSrc={svgAsImgSrc(<Icon />)}
        linkHref={Routes.shared_program_reference_materials_path(programId, { tag: libraryTag })}
        linkLabel={libraryLabel}
      >
        {assignments
          .sort((a, b) => a.label.localeCompare(b.label))
          .map(assignment => (
            <a
              key={`assignment-link-${assignment.id}`}
              href={assignment.href}
              rel="noopener noreferrer"
              target="_blank"
            >
              {assignment.label}
            </a>
          ))
        }
      </CardBody>
    </Card>
  );
};

export default ReferenceMaterialCard;
